module.exports = __webpack_public_path__ + "img/05.4c91ddfe.png";